import * as Cookies from 'js-cookie';
import * as React from 'react';

import 'lib/globals';
import Button from 'lj_shared/button/button';
const styles = require('./ask_notifications_permission.module.scss');
const logo = require('../../../../app/assets/images/logos/png/Landing_Logo_Color_Black.png');

interface Props {
  userType: string;
}

interface State {
  open: boolean;
  top: number;
}

export default class AskNotificationsPermission extends React.Component<Props, State> {
  readonly COOKIE_NAME = 'notifications-permissions';
  readonly PAGE_VIEWS_STORAGE_KEY = 'notifications-permissions-page-views';
  readonly MINIMUM_PAGE_VIEWS = 2;
  readonly TOP_OFFSET = 58;

  accepted = this.handleButton.bind(this, 'accepted');
  rejected = this.handleButton.bind(this, 'rejected');

  constructor(props) {
    super(props);
    this.state = { open: this.shouldOpen(), top: this.calculateTop() };
    this.updateTop = this.updateTop.bind(this);
  }

  componentDidMount() {
    $('.ld-wrapper').on('top-alert:recompute', this.updateTop);
  }

  componentWillUnmount() {
    $('.ld-wrapper').off('top-alert:recompute', this.updateTop);
  }

  calculateTop() {
    // HACK: compute this component's top based on the navbar margin-top
    const offset = $('.ld-wrapper').offset();
    const navbarTop = (offset && offset.top) || 0;
    return navbarTop + this.TOP_OFFSET;
  }

  updateTop() {
    this.setState({ top: this.calculateTop() });
  }

  shouldOpen() {
    if (!this.isPromptable()) {
      return false;
    }

    return this.registerPageView() >= this.MINIMUM_PAGE_VIEWS;
  }

  isPromptable() {
    return (
      window.Notification && Notification.permission === 'default' && !Cookies.get(this.COOKIE_NAME)
    );
  }

  // Asking on the very first page a user opens gives them no context about the
  // platform, so the prompt waits until they come back for a second page.
  registerPageView() {
    try {
      const storedViews = Number(localStorage.getItem(this.PAGE_VIEWS_STORAGE_KEY));
      const pageViews = (Number.isFinite(storedViews) ? storedViews : 0) + 1;
      localStorage.setItem(this.PAGE_VIEWS_STORAGE_KEY, String(pageViews));

      return pageViews;
    } catch {
      // Without storage we cannot tell first from second page, so we never ask
      return 0;
    }
  }

  handleButton(action, event) {
    event.preventDefault();
    this.setState({ open: false });

    if (action === 'accepted') {
      Notification.requestPermission();
    }
  }

  render() {
    if (this.state.open) {
      Cookies.set(this.COOKIE_NAME, 'true', { expires: 30 });
      const color = this.props.userType === 'TalentUser' ? 'puertoRico' : 'ripePlum';

      return (
        <div className={styles.container} style={{ top: this.state.top }}>
          <div className={styles.dialog}>
            <img className={styles.logo} src={logo} alt='Landing.Jobs' />
            <div className={styles.title}>Receiving Notifications</div>
            <div className={styles.text}>Would you like to subscribe to our notifications?</div>
            <div className={styles.note}>
              Why are we asking you this? By subscribing to notifications you will be able to keep
              better track of your account activity and applications.
            </div>
            <div className={styles.buttons}>
              <Button
                buttonColor='silverSand'
                buttonSize='xSmall'
                buttonType='border'
                isButton={true}
                onClick={this.rejected}
              >
                Maybe later
              </Button>
              <Button
                buttonColor={color}
                buttonSize='xSmall'
                isButton={true}
                onClick={this.accepted}
              >
                Yes, subscribe
              </Button>
            </div>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}
